import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

function getExpiresKey(cacheKey: string): string {
  return cacheKey + '.expires';
}

@Injectable({ providedIn: 'root' })
export class StorageAccessor {
  private onItemSubject: Subject<{ key: string; value: any }> = new Subject();

  getItem<T>(key: string): T {
    return JSON.parse(localStorage.getItem(key)!) as T;
  }

  getItemFromSession<T>(key: string): T {
    return JSON.parse(sessionStorage.getItem(key)!) as T;
  }

  setItem(key: string, value: any = null) {
    localStorage.setItem(key, JSON.stringify(value));
    this.onItemSubject.next({ key, value });
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
    this.onItemSubject.next({ key, value: null });
  }

  removeItemFromSession(key: string) {
    sessionStorage.removeItem(key);
  }

  setItemToSession<T>(key: string, value: T) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  cleanAll() {
    localStorage.clear();
    sessionStorage.clear();
  }

  removeFromCache(key: string) {
    this.removeItem(getExpiresKey(key));
    this.removeItem(key);
  }
}
